// extracted by mini-css-extract-plugin
export var body = "_e8-0";
export var sectionHeader = "_e8-4";
export var shortcutColumns = "_e8-2";
export var shortcutList = "_e8-1";
export var shortcutSection = "_e8-3";